import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from 'react';
import { LOCALES, LANGUAGES } from './index';

const CrmI18nContext = createContext(null);

export function CrmI18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    try { return localStorage.getItem('crm_locale') || 'de'; }
    catch { return 'de'; }
  });

  useEffect(() => {
    try { localStorage.setItem('crm_locale', locale); } catch {}
  }, [locale]);

  const translations = useMemo(() => LOCALES[locale] || LOCALES.de, [locale]);

  const t = useCallback((path, vars) => {
    const keys = path.split('.');
    let val = translations;
    for (const k of keys) {
      if (val == null) return path;
      val = val[k];
    }
    if (val == null) {
      let fallback = LOCALES.de;
      for (const k of keys) {
        if (fallback == null) return path;
        fallback = fallback[k];
      }
      val = fallback;
    }
    if (val == null) return path;
    if (typeof val === 'string' && vars) {
      return val.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : `{${k}}`));
    }
    return val;
  }, [translations]);

  const ctx = useMemo(() => ({ t, locale, setLocale, LANGUAGES }), [t, locale]);

  return (
    <CrmI18nContext.Provider value={ctx}>
      {children}
    </CrmI18nContext.Provider>
  );
}

export function useCrmI18n() {
  const ctx = useContext(CrmI18nContext);
  if (!ctx) throw new Error('useCrmI18n must be used within CrmI18nProvider');
  return ctx;
}
